<template>
<div>
  <MainHeading :title="title" :subtitle="subtitle" />

  <div class="project_container" v-if="title === '5 Spaces'">
    <p>
      This project is based off of the city Valdrada from Invisible Cities by
      Italo Calvino. It is meant to be a proposal of five spaces. A lookout,
      study, alcove, gathering, and an overlook.
    </p>
    <div class="picGrid" id="PicGrid1"></div>
    <p>
      The city is on the shores of a lake and the reflection in the water was
      a very prominent part in the story. The reflection showed the citizens
      true colors. Because of this, I interpreted Valdrada as a dark place to
      live. The lake separates the public spaces from the private ones. The
      public side mimicks the reflection idea. It is a reversed version of the
      private side but it is contorted, as a reflection typically does. It has
      larger windows to show the true dark colors of the Valdrada citizens.
    </p>
    <div class="picGrid" id="PicGrid2"></div>
    <div class="picGrid" id="PicGrid3"></div>
    <div class="picGrid lastGrid" id="Pic4"></div>
  </div>

  <div class="project_container" v-if="title === 'Hanselmann House'">
    <p>
      I was assigned the Hanselmann House to study the way it was designed,
      what it was designed for, and important features of the house. I was
      tasked with modeling the house in Rhino. Taking what I researched about
      it, I had to create diagrams to show important pieces of the building.
    </p>
    <div class="picGrid lastGrid" id="HanselmannGrid"></div>
  </div>

  <div class="project_container" v-if="title === 'Ice Pavillion'">
    <p>
      The ice pavilion is an enclosure system meant to accommodate 57,400
      pounds of ice. The site was located in Burnet Woods. The fact that the
      site slopes had to be taken into consideration. I chose to study prisms
      and use that as my driving force for the project. I came to learn that
      the prisms naturally curved once inserted in one another. A plan and
      section were drafted in Rhino. Then a physical model was created based
      off of the digital drawings.
    </p>
    <div class="picGrid lastGrid" id="IceGrid"></div>
  </div>

  <div class="project_container" v-if="title === 'Studio'">
    <p>
      The studio space where we worked in the DAAP building was to be
      measured. After getting the dimensions of the whole room, it was drafted
      into Rhino. We were required to have a plan and two sections showing
      different parts of the space. The 2D model was then inserted into Adobe
      Illustrator to add colors and make it appear more artistic.
    </p>
    <div class="picGrid lastGrid" id="StudioGrid"></div>
  </div>

  <div class="project_container" v-if="title === 'Unit Wall'">
    <p>
      The purpose of this project was to look at the relationship between
      space and the human body. As a team, we designed a modular unit that
      acts similarly to a brick. They had to be stacked on top of each other.
      Enough units had to be constructed to build an 8' x 8' wall/screen. The
      wall should engage with the body and the specific site it was installed
      in.
      <br /><br />
      My team decided to mainly use recycled materials. This lead to us using
      wood palettes to create the unit. Plastic bags were made into "plarn" or
      plastic bag yarn and they were weaved through the unit.
    </p>

    <div class="picGrid lastGrid" id="UnitGrid"></div>
  </div>
</div>
</template>

<script src="./Project.js"></script>

<style lang="scss" src="./Project.scss" scoped></style>
